import ENDPOINTS from "../ApiManager/EmpleadoEndPoints";
import environment from "../environments/environment";

const BASE_URL = environment.api_url;

class EmpleadoService {

	static getEmpleados = (establecimientoId) => {
		const url = BASE_URL + ENDPOINTS.GET_EMPLEADOS() + establecimientoId;
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};


	static getTiposEmpleado = () => {
		const url = BASE_URL + ENDPOINTS.GET_TIPOS_EMPLEADO();
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}

		});
	};

	static getEmpleadosByParams = (establecimientoId, activo, nombre, idTipo) => {
		const url = BASE_URL + ENDPOINTS.GET_EMPLEADOS_BY_PARAMS(establecimientoId, activo, nombre, idTipo);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};



	static crearEmpleado = (empleado) => {
		const url = BASE_URL + ENDPOINTS.POST_EMPLEADOS();

		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				nombre: empleado.nombre,
				tipo: empleado.tipo,
				apellidos: empleado.apellidos,
				email: empleado.email,
				telefono: empleado.telefono,
				establecimiento: empleado.establecimiento,
				activo: empleado.activo
			})

		});
	};

	static actualizarEmpleado = (empleado) => {
		const url = BASE_URL + ENDPOINTS.ACTUALIZAR_EMPLEADO(empleado.id);

		return fetch(url, {
			method: 'PUT',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				nombre: empleado.nombre,
				tipo: empleado.tipo,
				apellidos: empleado.apellidos,
				email: empleado.email,
				telefono: empleado.telefono,
				establecimiento: empleado.establecimiento,
				activo: empleado.activo
			})
		});
	};



	static desactivarEmpleado = (empleadoId) => {
		const url = BASE_URL + ENDPOINTS.DELETE_EMPLEADO() + empleadoId;

		return fetch(url, {
			method: 'DELETE',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};

	static asignarHabitaciones = (idEmpleado, listaHabitaciones) => {
		const url = BASE_URL + ENDPOINTS.ASIGNAR_HABITACIONES();

		return fetch(url, {
			method: 'PUT',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				empleado: idEmpleado,
				listaHabitaciones: listaHabitaciones
			})
		});
	};


}

export default EmpleadoService;